import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3 className="footer-title">MyZmaj.net</h3>
          <div className="footer-info">
            <div className="footer-info-item">
              <span className="footer-icon">📍</span>
              <span>Bulevar 12. Februara 4<br />18000 Niš, Srbija</span>
            </div>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-title">Ostale Usluge</h3>
          <ul className="footer-links">
            <li>
              <a href="https://myzmaj.rs/" target="_blank" rel="noopener noreferrer">
                Internet
              </a>
            </li>
            <li>
              <a href="https://myzmaj.com/" target="_blank" rel="noopener noreferrer">
                Video nadzor
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
                    <h3 className="footer-title">Kontakt</h3>
                        <div className="footer-info-item">
                      <span className="footer-icon">📞</span>
                      <span>+381 18 268465</span>
                    </div>
                    <div className="footer-info-item">
                      <span className="footer-icon">📞</span>
                      <span>+381 63 1921680</span>
                    </div>
                    <div className="footer-info-item">
                      <span className="footer-icon">📧</span>
                      <a href="mailto:info@myzmaj.net">info@myzmaj.net</a>
                    </div>
                    <div className="footer-info-item">
                      <span className="footer-icon">🌐</span>
                      <a href="https://www.myzmaj.net">www.myzmaj.net</a>
                    </div>

                    </div>
        <div className="footer-column">
          <div className="footer-section">
            <h3 className="footer-title">Radno Vreme</h3>
            <div className="footer-info-item">
              <span className="footer-icon">🕒</span>
              <div>
                <p>Ponedeljak - Petak: 9:00 - 17:00</p>
                <p>Subota: 9:00 - 15:00</p>
                <p>Nedelja: Zatvoreno</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">&copy; 2025 MyZmaj.net - Sva prava zadržana</p>
        <div className="footer-legal">
          <a href="/politika-privatnosti">Politika Privatnosti</a>
          <a href="/uslovi-koriscenja">Uslovi Korišćenja</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;